import {
  DatePicker,
  Empty,
  Flex,
  Form,
  Progress,
  Spin,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Button,
  Card,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import FormSelect from "../form-components/SelectComponent";
import purchaseOrderCreation from "../../api/purchase-orders/pruchaseOrderCreation";
import SearchInput from "../form-components/SearchComponent";
import { SearchOutlined } from "@ant-design/icons";
import invoiceApis from "../../api/Invoice/invoice";
import dispatchApis from "../../api/dispatch/dispatch";
import budgetApis from "../../api/master/budget";
import purchaseRequestApis from "../../api/master/purchaseRequest";
import quotationApis from "../../api/master/quotations";
import supplierApis from "../../api/master/supplier";
import usersApis from "../../api/master/users";
import materialsApis from "../../api/master/materials";
import taxMasterApis from "../../api/master/taxmaster";
import Export from "../../components/export/Export";
import paymentApis from "../../api/payments/payments";
import dayjs from "dayjs";
import misc from "../../api/misc/dropDowns";
import miscService from "../../api/misc/misc";
import { InfoCircleOutlined } from "@ant-design/icons";
import creditDebitNoteApis from "../../api/credit-debit-note/credit-debit-note";
import inventoryCreation from "../../api/inventory/inventoryCreation";
import boqApis from "../../api/boq/boq";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import BulkUpload from "../../components/upload/BulkUpload";
import FormMultiSelect from "../form-components/MultiSelectComponent";

import workCategoryApi from "../../api/master/workCategory";

import rateContract from "../../api/rate-contract/rateContract";
import labourMasterApis from "../../api/master/labourMaster";
import toolMasterApis from "../../api/master/toolMaster";
import brandMasterApis from "../../api/master/brandMaster";
import locationMasterApis from "../../api/master/locationMaster";
import sitebreakdownMasterApis from "../../api/master/sitebreakdownMaster";
import returnsApis from "../../api/returns/returns";
import gateEntryApis from "../../api/master/gateEntry";

const { RangePicker } = DatePicker;
type WidgetType = {
  title: string;
  key: string;
  color: string;
  percentage: number;
  value: number;
};
type SelectOptions = {
  label: string;
  value: string;
};
type SelectFilterType = {
  title: string;
  placeholder?: string;
  options: SelectOptions[];
  onChange?: (value: any) => void;
  selectionMode?: "multiple" | "single";
};
const TransactionFlowDefaultTemplate: React.FC<any> = ({
  title,
  moduleKey,
  widget,
  columns,
  sideNavigation,
  selectFilters,
  previousPath,
  extra,
  topRightJSX,
  refresh,
  components,
  rowSelection,
  form,
  extraFilterParams,
  customFiltersJSX,
  onSelectFilter1Change,
  onDataLoaded,
}: {
  title: string;
  moduleKey: string;
  columns: any[];
  sideNavigation?: any;
  widget?: {
    progressCircle?: boolean;
    isActive: boolean;
    list: WidgetType[];
  };
  selectFilters?: SelectFilterType[];
  previousPath?: string;
  topRightJSX?: any;
  extra?: {
    id?: any;
    tableScrollX?: number;
    dateRange?: boolean;
    excelExport?: boolean;
    bulkUpload?: boolean;
    dataFilterTootip?: string;
    clientSideSearch?: boolean;
  };
  refresh?: boolean;
  components?: any;
  rowSelection?: any;
  form?: any;
  extraFilterParams?: Record<string, any>;
  customFiltersJSX?: React.ReactNode;
  onSelectFilter1Change?: (value: any) => void;
  onDataLoaded?: (rows: any[]) => void;
}) => {
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const [customDateRange, setCustomDateRange] = useState<any>();
  const [dataSource, setDataSource] = useState<any>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    defaultCurrent: 1,
    defaultPageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30", "40", "50"],

    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [screenSize, setScreenSize] = useState(0);

  const [searchQuery, setsearchQuery] = useState(null);
  const [clientSearchText, setClientSearchText] = useState("");
  const { data: currentUser } = useSelector((state: any) => state.currentUser);

  const selectFilter1 = watch("selectFilter1");
  const selectFilter2 = watch("selectFilter2");
  const selectFilter3 = watch("selectFilter3");
  const dateRange = watch("dateRange");
  //---------------------------------------- Functions Start ----------------------------------------

  const fetchData = async (params: any) => {
    setLoading(true);
    try {
      const {
        current,
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        searchQuery,
        selectFilter1,
        selectFilter2,
        selectFilter3,
        dateRange,
        customDateRange,
      } = params;
      if (
        extra?.dateRange &&
        ((dateRange == "Custom Date" && customDateRange == undefined) ||
          dateRange == undefined)
      )
        return;
      const { from, to }: any =
        dateRange !== undefined && convertToDates(dateRange);
      let apiResponse: any = {};
      switch (moduleKey) {
        case "/bulk-upload-list":
          apiResponse =
            await miscService.fetchBulkUploadRequestedListWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
            });
          break;
        case "excelexport-requested-list":
          apiResponse =
            await miscService.fetchExcelExportRequestedListWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
            });
          break;
        case "view-rate-contract":
          apiResponse = await rateContract.fetchAllRateContracts({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            siteIds: selectFilter2?.join(",") ? selectFilter2?.join(",") : null,
            startDate: from,
            endDate: to,
          });
          // Transform the response to match column structure
          if (apiResponse?.status && apiResponse?.data?.list) {
            apiResponse.data.list = apiResponse.data.list.map((item: any) => ({
              ...item,
              orderId: item.contractReferenceId,
              orderNumber: item.contractReferenceId,
              orderDate: item.contractDate,
              needByDate: item.startDate, // For Start Date column
              endDate: item.endDate, // For End Date column
              createdUserName: item.createdByName,
              createdDate: item.createdAt,
              orderStatus: item.status || item.approvalStatus,
              siteName:
                item.contractSites
                  ?.map((site: any) => site.siteName)
                  .join(", ") || item.siteName,
            }));
          }
          break;
        case "purchase-order-upload":
          apiResponse =
            await purchaseOrderCreation.fetchAllOrgOrdersWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              orderStatus: selectFilter1,
              siteIds: selectFilter2?.join(",")
                ? selectFilter2?.join(",")
                : null,
              startDate: from,
              endDate: to,
            });
          break;
        case "approvals-rate-contract":
          apiResponse = await rateContract.fetchPendingApprovals({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
          });
          // Transform the response to match column structure
          if (apiResponse?.status && apiResponse?.data?.list) {
            apiResponse.data.list = apiResponse.data.list.map((item: any) => ({
              ...item,
              orderId: item.contractReferenceId,
              orderNumber: item.contractReferenceId,
              orderDate: item.contractDate,
              needByDate: item.startDate, // For Start Date column
              endDate: item.endDate, // For End Date column
              createdUserName: item.createdByName,
              createdDate: item.createdAt,
              orderStatus: item.status || item.approvalStatus,
              siteName:
                item.contractSites
                  ?.map((site: any) => site.siteName)
                  .join(", ") ||
                item.siteName ||
                "",
            }));
          }
          break;
        case "approvals-purchase-order":
          apiResponse =
            await purchaseOrderCreation.fetchUserPendingApprovalOrdersWithPagination(
              {
                sortOrder,
                pageSize,
                direction,
                pageDiff,
                paginationId,
                searchQuery,
                siteIds: selectFilter1?.join(",")
                  ? selectFilter1?.join(",")
                  : null,
                startDate: from,
                endDate: to,
              }
            );
          break;
        case "invoice-grn-upload":
          apiResponse = await invoiceApis.fetchAllInvoicesWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            invoiceStatus: selectFilter1,
            siteIds: selectFilter2?.join(",")
              ? selectFilter2?.join(",")
              : null,
            startDate: from,
            endDate: to,
          });
          break;
        case "all-credit-debit-notes":
          apiResponse =
            await creditDebitNoteApis.fetchAllCreditDebitNotesWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              siteIds: selectFilter1?.join(",")
                ? selectFilter1?.join(",")
                : null,
              supplierIds: selectFilter2?.join(",")
                ? selectFilter2?.join(",")
                : null,
            });
          break;
        case "pending-approval-credit-debit-notes":
          apiResponse =
            await creditDebitNoteApis.fetchAllUserPendingConfirmationCreditDebitNotesWithPagination(
              {
                sortOrder,
                pageSize,
                direction,
                pageDiff,
                paginationId,
                searchQuery,
              }
            );
          break;
        case "view-dispatch-list":
          apiResponse =
            await dispatchApis.fetchAllGrnPendingDispatchesWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              startDate: from,
              endDate: to,
              siteIds: selectFilter1?.join(",")
                ? selectFilter1?.join(",")
                : null,
            });
          break;
        case "pending-approvals-grn-list":
          apiResponse =
            await dispatchApis.fetchAllUserPendingApprovalGrnsWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              startDate: from,
              endDate: to,
              siteIds: selectFilter1?.join(",")
                ? selectFilter1?.join(",")
                : null,
            });
          break;
        case "delivered-dispatch-list":
          apiResponse =
            await dispatchApis.fetchAllDeliveredDispatchesWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              startDate: from,
              endDate: to,
              siteIds: selectFilter1?.join(",")
                ? selectFilter1?.join(",")
                : null,
            });
          break;
        case "view-budget-list":
          apiResponse = await budgetApis.fetchBudgetListPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            siteIds: selectFilter2?.join(",")
              ? selectFilter2?.join(",")
              : null,
            startDate: from,
            endDate: to,
          });
          break;
        case "pendingApproval-budget":
          apiResponse = await budgetApis.fetchBudgetPaginationPendingApprovals({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            siteIds: selectFilter1?.join(",")
              ? selectFilter1?.join(",")
              : null,
          });
          break;
        case "purchase-request-upload":
          apiResponse = await purchaseRequestApis.fetchPrListPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            siteIds: selectFilter2?.join(",") ? selectFilter2?.join(",") : null,
            startDate: from,
            endDate: to,
          });
          break;
        case "approvals-purchase-request":
          apiResponse =
            await purchaseRequestApis.fetchPrPaginationPendingApprovals({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              siteIds: selectFilter1?.join(",") ? selectFilter1?.join(",") : null,
              startDate: from,
              endDate: to,
            });
          break;
        case "view-rfqs":
          apiResponse = await quotationApis.fetchRFQPaginationList({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            overallStatus: selectFilter1,
            siteIds: selectFilter2?.join(",") ? selectFilter2?.join(",") : null,
            startDate: from,
            endDate: to,
          });
          break;
        case "rfq-approvals":
          apiResponse = await quotationApis.fetchRFQPaginationPendingApprovals({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            siteIds: selectFilter2?.join(",") ? selectFilter2?.join(",") : null,
            startDate: from,
            endDate: to,
          });
          break;
        case "pending-payment-approvals":
          apiResponse =
            await paymentApis.fetchUserPendingApprovalPaymentsWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              siteIds: selectFilter1?.join(",")
                ? selectFilter1?.join(",")
                : null,
              startDate: from,
              endDate: to,
            });
          break;
        case "run-payments":
          apiResponse =
            await paymentApis.fetchAllPendingRunPaymentsWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              supplierFilters: Array.isArray(selectFilter1)
                ? selectFilter1.join(",")
                : selectFilter1 || null,
              siteIds: selectFilter2?.join(",")
                ? selectFilter2?.join(",")
                : null,
              startDate: from,
              endDate: to,
            });
          break;
        case "view-payments":
          apiResponse = await paymentApis.fetchAllPaidInvoicesWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            siteIds: selectFilter1?.join(",")
              ? selectFilter1?.join(",")
              : null,
            startDate: from,
            endDate: to,
          });
          break;
        case "payments-upload":
          apiResponse =
            await paymentApis.fetchPayableInvoicesForPaymentsWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              supplierFilters: selectFilter1,
              siteIds: Array.isArray(selectFilter2)
                ? selectFilter2?.join(",")
                : selectFilter2 || null,
            });
          // for editable rows key is added (mandatory)
          const { data, status } = apiResponse;
          if (status) {
            apiResponse.data = {
              ...data,
              list: data?.list?.map((row: any) => {
                return {
                  ...row,
                  key: row?.invoiceNumber,
                };
              }),
            };
          }
          break;
        case "suppliers-list":
          apiResponse = await supplierApis.fetchSupplierWithPagenation({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            categoryFilters: selectFilter1,
          });
          break;
        case "taxmaster-list":
          apiResponse = await taxMasterApis.fetchTaxWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
          });
          // console.log("Tax API response:", apiResponse);
          break;
        case "labourmaster-list":
          apiResponse = await labourMasterApis.fetchLabourWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
          });
          break;
        case "toolmaster-list":
          apiResponse = await toolMasterApis.fetchToolWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
          });
          break;
        case "brandmaster-list":
          apiResponse = await brandMasterApis.fetchBrandWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
          });
          break;
        case "locationmaster-list":
          apiResponse = await locationMasterApis.fetchLocationWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            id: selectFilter1,
            status: selectFilter2,
          });
          break;
        case "sitebreakdownmaster-list":
          apiResponse =
            await sitebreakdownMasterApis.fetchSiteBreakDownWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
            });
          break;

        case "users-list":
          apiResponse = await usersApis.fetchBuyerUserWithPagenation({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
          });
          break;
        case "material-list":
          apiResponse = await materialsApis.fetchProductWithPagenation({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            categoryFilters: selectFilter1,
            materialTypeFilters: selectFilter2,
          });
          break;
        case "qc-list":
          apiResponse = await quotationApis.fetchQCPagination({
            sortOrder,
            pageSize,
            direction: "P",
            pageDiff: current,
            paginationId,
            siteIds: selectFilter1?.join(",") ? selectFilter1?.join(",") : null,
            startDate: from,
            endDate: to,
            searchQuery,
          });
          break;
        case "qc-approvals":
          apiResponse =
            await quotationApis.fetchQCApprovalsPaginationPendingApprovals({
              sortOrder,
              pageSize,
              direction: "P",
              pageDiff: current,
              paginationId,
              siteIds: selectFilter1?.join(",") ? selectFilter1?.join(",") : null,
              startDate: from,
              endDate: to,
              searchQuery,
            });
          break;
        case "ready-to-award":
          apiResponse =
            await quotationApis.fetchReadyToRewardPaginationPendingApprovals({
              sortOrder,
              pageSize,
              direction: "P",
              pageDiff: current,
              paginationId,
              siteIds: selectFilter1?.join(",")
                ? selectFilter1?.join(",")
                : null,
              searchQuery,
            });
          break;
        case "stock-availability":
          // Handle multi-select filters by joining arrays with commas
          apiResponse = await inventoryCreation.fetchSiteInventoryPagiantion({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            siteId: Array.isArray(selectFilter1)
              ? selectFilter1.join(",")
              : selectFilter1 || undefined,
            categoryId: Array.isArray(selectFilter2)
              ? selectFilter2.join(",")
              : selectFilter2 || undefined,
            materialId: Array.isArray(selectFilter3)
              ? selectFilter3.join(",")
              : selectFilter3 || undefined,
          });
          break;
        case "consumption-target-list":
          apiResponse = await boqApis.fetchConsumptionTarget({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            siteIds: Array.isArray(selectFilter1)
              ? selectFilter1.join(",")
              : selectFilter1,
          });
          break;
        case "work-category-list":
          apiResponse = await workCategoryApi.fetchWorkCategories();
          if (apiResponse.status) {
            apiResponse.data = {
              list: apiResponse.data,
              count: apiResponse.data.length,
            };
          }
          break;
        case "MaterialIssueList":
          apiResponse = await inventoryCreation.fetchMaterialIssue({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            siteIds: Array.isArray(selectFilter1)
              ? selectFilter1.join(",")
              : selectFilter1 || undefined,
            startDate: from,
            endDate: to,
            searchQuery,
            ...(extraFilterParams || {}),
          });
          break;
        case "MaterialHandoverList":
          apiResponse = await inventoryCreation.fetchMaterialHandOver({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            siteIds: Array.isArray(selectFilter1)
              ? selectFilter1.join(",")
              : selectFilter1 || undefined,
            contractorIds: Array.isArray(selectFilter2)
              ? selectFilter2.join(",")
              : selectFilter2 || undefined,
            startDate: from,
            endDate: to,
            searchQuery
          });
          break;
        case "MaterialHandoverPendingList":
          apiResponse = await inventoryCreation.fetchMaterialPendingHandOver({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            siteIds: Array.isArray(selectFilter1)
              ? selectFilter1.join(",")
              : selectFilter1 || undefined,
            contractorIds: Array.isArray(selectFilter2)
              ? selectFilter2.join(",")
              : selectFilter2 || undefined,
            startDate: from,
            endDate: to,
            searchQuery
          });
          break;
        case "MaterialUtilizationList":
          apiResponse = await inventoryCreation.fetchMaterialUtilization({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            siteIds: Array.isArray(selectFilter1)
              ? selectFilter1.join(",")
              : selectFilter1 || undefined,
            contractorIds: Array.isArray(selectFilter2)
              ? selectFilter2.join(",")
              : selectFilter2 || undefined,
            startDate: from,
            endDate: to,
            searchQuery
          });
          break;
        case "MaterialIssuePendingApprovals":
          apiResponse = await inventoryCreation.fetchPendingApprovals({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            siteIds: Array.isArray(selectFilter1)
              ? selectFilter1.join(",")
              : selectFilter1 || undefined,
            categoryId: Array.isArray(selectFilter2)
              ? selectFilter2.join(",")
              : selectFilter2 || undefined,
          });
          break;
        case "view-returns":
          apiResponse = await returnsApis.fetchAllReturnsWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            siteIds: selectFilter1?.join(",") ? selectFilter1?.join(",") : null,
            startDate: from,
            endDate: to,
          });
          break;
        case "pending-approvals-returns":
          apiResponse =
            await returnsApis.fetchAllPendingApprovalReturnsWithPagination({
              sortOrder,
              pageSize,
              direction,
              pageDiff,
              paginationId,
              searchQuery,
              siteIds: selectFilter1?.join(",")
                ? selectFilter1?.join(",")
                : null,
              startDate: from,
              endDate: to,
            });
          break;
        case "gate-entry":
          // Get siteid from currentUser's siteAccessibility
          let siteid = null;
          if (
            currentUser?.siteAccessibility &&
            currentUser.siteAccessibility.length > 0
          ) {
            const siteIds = currentUser.siteAccessibility.map(
              (item: any) => item.siteID
            );
            siteid = siteIds.join(",");
          }
          apiResponse = await gateEntryApis.fetchGateEntryWithPagination({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            id: siteid,
          });
          break;
        default:
          alert("Invalid key " + moduleKey);
      }

      const { data, status } = apiResponse;
      if (status) {
        const { list, count } =
          data || apiResponse.response.data || apiResponse.response;
        setDataSource(list);
        if (typeof onDataLoaded === "function") {
          onDataLoaded(list || []);
        }
        setPagination((prev) => ({
          ...prev,
          total: Number(count),
        }));
      }
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const convertToDates = (dateType: string) => {
    try {
      switch (dateType) {
        case "Month to Date":
          return {
            from: dayjs().startOf("month").format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        case "Quarter to Date":
          return {
            from: dayjs()
              .subtract(3, "month")
              .startOf("month")
              .format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        case "Year to Date":
          return {
            from: dayjs().startOf("year").format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        default:
          if (!customDateRange)
            return {
              from: dayjs()?.format("YYYY-MM-DD"),
              to: dayjs()?.format("YYYY-MM-DD"),
            };
          return {
            from: dayjs(customDateRange[0]).format("YYYY-MM-DD"),
            to: dayjs(customDateRange[1]).format("YYYY-MM-DD"),
          };
      }
    } catch (error) {
      return {
        from: dayjs()?.format("YYYY-MM-DD"),
        to: dayjs()?.format("YYYY-MM-DD"),
      };
    }
  };

  const tableOnChange = async (
    newPagination: any,
    filters: any,
    sorter: any
  ) => {
    const apiParams = {
      oldPage: pagination.current,
      current: newPagination.current?.toString(),
      sortOrder: "DESC",
      pageSize: newPagination.pageSize || pagination.pageSize,
      direction: "P",
      pageDiff: 0,
      paginationId: null,
      searchQuery,
    };

    if (sorter.order) {
      apiParams.sortOrder = sorter.order === "ascend" ? "ASC" : "DESC";
    } else if (newPagination.pageSize != pagination.pageSize) {
      // if page size is changed
      apiParams.pageSize = newPagination.pageSize;
      const _currentPage =
        Math.floor(
          ((Number(pagination.current) - 1) * Number(pagination.pageSize)) /
          Number(newPagination.pageSize)
        ) + 1; // calculating new current page based on new page size
      apiParams.current = _currentPage.toString();
      apiParams.pageDiff = _currentPage - 1;
    } else {
      if (newPagination.current != pagination.current) {
        apiParams.direction =
          newPagination.current > pagination.current
            ? "F" // Forward
            : "B"; // Backward

        if (apiParams.direction === "F" && dataSource.length > 0) {
          apiParams.paginationId =
            dataSource[dataSource.length - 1]?.paginationId;
        } else if (apiParams.direction === "B" && dataSource.length > 0) {
          apiParams.paginationId = dataSource[0]?.paginationId;
        }

        apiParams.pageDiff =
          Math.abs(newPagination.current - pagination.current) - 1;
      }
    }

    setPagination({
      ...pagination,
      current: Number(apiParams.current),
      pageSize: Number(apiParams.pageSize),
    });
    await fetchData({
      ...apiParams,
      selectFilter1,
      selectFilter2,
      selectFilter3,
      dateRange,
      customDateRange,
    });
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  //---------------------------------------- Functions End----------------------------------------

  const refreshData = () => {
    // Reset filters when refreshing the page
    setValue("selectFilter1", undefined);
    setValue("selectFilter2", undefined);
    setValue("selectFilter3", undefined);
    setCustomDateRange(undefined);
    const _dateRange = extra?.dateRange ? "Quarter to Date" : undefined;
    setValue("dateRange", _dateRange);
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));

    fetchData({
      oldPage: 1,
      current: "1",
      sortOrder: "DESC",
      pageSize: pagination.pageSize.toString(),
      direction: "P",
      pageDiff: 0,
      paginationId: null,
      searchQuery,
      selectFilter1: undefined,
      selectFilter2: undefined,
      selectFilter3: undefined,
      dateRange: _dateRange,
      customDateRange: undefined,
    });
  };
  useEffect(() => {
    if (extra?.dateRange) {
      setValue("dateRange", "Quarter to Date");
    }
    refreshData();
  }, [refresh]);

  // Initial mount: set dateRange if required
  useEffect(() => {
    if (extra?.dateRange && !dateRange) {
      setValue("dateRange", "Quarter to Date");
    }
  }, []);

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  useEffect(() => {
    if (
      selectFilter1 !== undefined ||
      selectFilter2 !== undefined ||
      selectFilter3 !== undefined ||
      dateRange !== undefined ||
      customDateRange !== undefined ||
      extraFilterParams !== undefined
    ) {
      setPagination({
        ...pagination,
        current: 1,
      });
      fetchData({
        oldPage: 1,
        current: pagination.current.toString(),
        sortOrder: "DESC",
        pageSize: pagination.pageSize.toString(),
        direction: "P",
        pageDiff: 0,
        paginationId: null,
        searchQuery,
        selectFilter1,
        selectFilter2,
        selectFilter3,
        dateRange,
        customDateRange,
      });
    }
  }, [selectFilter1, selectFilter2, selectFilter3, dateRange, customDateRange, JSON.stringify(extraFilterParams)]);

  // Notify parent when site filter (selectFilter1) changes — used by pages
  // that need to drive cascading hierarchy filters from the selected site.
  useEffect(() => {
    if (typeof onSelectFilter1Change === "function") {
      onSelectFilter1Change(selectFilter1);
    }
  }, [selectFilter1]);

  // Clear customDateRange when switching away from Custom Date
  useEffect(() => {
    if (dateRange && dateRange !== "Custom Date") {
      setCustomDateRange(undefined);
    }
  }, [dateRange]);

  const getSearchableColumnKeys = () =>
    (columns || [])
      .map((col: any) => col?.dataIndex)
      .filter(
        (key: any) => typeof key === "string" && key && key !== "actions"
      );

  const filteredDataSource = (() => {
    if (!extra?.clientSideSearch) return dataSource;
    const q = (clientSearchText || "").trim().toLowerCase();
    if (!q) return dataSource;
    const keys = getSearchableColumnKeys();
    return (dataSource || []).filter((row: any) =>
      keys.some((key: string) => {
        const v = row?.[key];
        if (v === null || v === undefined) return false;
        if (Array.isArray(v)) return v.join(",").toLowerCase().includes(q);
        return String(v).toLowerCase().includes(q);
      })
    );
  })();

  const effectivePagination = extra?.clientSideSearch
    ? {
        defaultPageSize: pagination.defaultPageSize,
        pageSize: pagination.pageSize,
        showSizeChanger: pagination.showSizeChanger,
        pageSizeOptions: pagination.pageSizeOptions,
        total: filteredDataSource?.length || 0,
      }
    : pagination;

  return (
    <>
      <Head title={title} />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {sideNavigation}
            <div className="card-inner card-inner-lg">
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent className="w-100">
                    <BlockTitle
                      tag="h4"
                      className="d-flex justify-content-between align-items-center  w-100"
                    >
                      <span>{title}</span>
                    </BlockTitle>
                  </BlockHeadContent>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <Button
                        className={`btn-icon btn-trigger toggle-expand me-n1`}
                      >
                        <Icon name="menu-alt-r"></Icon>
                      </Button>
                      <div className="toggle-expand-content">
                        <ul className="nk-block-tools g-3">
                          {extra?.excelExport && (
                            <li>
                              <Export
                                data={{
                                  sortOrder: "DESC",
                                  pageSize: 100,
                                  direction: "P",
                                  pageDiff: 0,
                                  searchQuery,
                                  selectFilter1:
                                    moduleKey === "stock-availability" &&
                                      Array.isArray(selectFilter1)
                                      ? selectFilter1.join(",")
                                      : selectFilter1,
                                  selectFilter2:
                                    moduleKey === "stock-availability" &&
                                      Array.isArray(selectFilter2)
                                      ? selectFilter2.join(",")
                                      : selectFilter2,
                                  selectFilter3:
                                    moduleKey === "stock-availability" &&
                                      Array.isArray(selectFilter3)
                                      ? selectFilter3.join(",")
                                      : selectFilter3,
                                  dateRange:
                                    dateRange && convertToDates(dateRange),
                                  customDateRange,
                                }}
                                moduleKey={moduleKey}
                              />
                            </li>
                          )}
                          {extra?.bulkUpload && (
                            <li>
                              <BulkUpload
                                moduleKey={moduleKey}
                                showAsButton={true}
                              />
                            </li>
                          )}
                          <li className="nk-block-tools-opt">{topRightJSX}</li>
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <Block>
                {widget?.isActive && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "nowrap",
                      width: "100%",
                      gap: "8px",
                    }}
                  >
                    {widget?.list.map((widgets, index) => {
                      const widgetCount = widget?.list?.length || 1;
                      const widgetWidth = `calc(${100 / widgetCount}% - ${((widgetCount - 1) * 8) / widgetCount
                        }px)`;
                      return (
                        <div
                          key={index}
                          style={{
                            border: "1px solid #dbdfea",
                            padding: "8px",
                            borderRadius: "6px",
                            width: widgetWidth,
                            minWidth: "0",
                            flexShrink: 1,
                          }}
                        >
                          <div style={{ marginBottom: "8px" }}>
                            <h6
                              style={{
                                margin: 0,
                                fontSize: "12px",
                                fontWeight: 500,
                              }}
                            >
                              {widgets.title}
                            </h6>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {widget.progressCircle && (
                              <div style={{ flex: 1 }}>
                                <Progress
                                  type="circle"
                                  percent={
                                    Number(widgets?.percentage)
                                      ?.toFixed(2)
                                      ?.toString() as any
                                  }
                                  width={40}
                                  strokeColor={widgets.color}
                                  format={(percent) => `${Number(percent)}%`}
                                />
                              </div>
                            )}

                            <div style={{ flex: 1, textAlign: "center" }}>
                              <p
                                style={{
                                  fontSize: "16px",
                                  margin: 0,
                                  fontWeight: 600,
                                }}
                              >
                                {widgets.value}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </Block>
              <FormProvider {...methods}>
                <form className="w-100 d-flex align-items-center justify-content-start">
                  {(selectFilters && selectFilters?.length > 0) ||
                    extra?.dateRange ||
                    customFiltersJSX ? (
                    <div className="d-flex align-items-start flex-wrap w-75 mb-2">
                      {/* {selectFilters && selectFilters?.length > 0 || extra?.dateRange && ( */}
                      <div className="d-flex align-items-center flex-wrap w-100">
                        {selectFilters?.map(
                          (filter: SelectFilterType, index: any) => {
                            return (
                              <div
                                key={"filters" + index}
                                className="mt-1 mb-0 w-25"
                                style={{ marginRight: 10 }}
                              >
                                {filter?.selectionMode !== "multiple" ? (
                                  <FormSelect
                                    name={`selectFilter${index + 1}`}
                                    label={filter?.title}
                                    // required={false}
                                    hideRequiredMark={true}
                                    placeholder={
                                      filter?.placeholder || filter?.title
                                    }
                                    options={filter?.options}
                                    onChange={(e: any) => {
                                      if (
                                        typeof filter.onChange === "function"
                                      ) {
                                        filter.onChange(e);
                                      }
                                    }}
                                  />
                                ) : (
                                  <>
                                    <div
                                      key={"filters" + index}
                                      className="mt-1 mb-0"
                                      style={{ marginRight: 10 }}>
                                      <FormMultiSelect
                                        name={`selectFilter${index + 1}`}
                                        label={filter?.title}
                                        // required={false}
                                        // hideRequiredMark={true}
                                        placeholder={
                                          filter?.placeholder || filter?.title
                                        }
                                        options={filter?.options}
                                        onChange={(e: any) => {
                                          if (
                                            typeof filter.onChange === "function"
                                          ) {
                                            filter.onChange(e);
                                          }
                                        }}
                                      />
                                    </div>
                                  </>
                                )
                                }
                              </div>
                            );
                          }
                        )}
                        {extra?.dateRange && (
                          <div className="w-50" style={{ display: "contents" }}>
                            <div
                              className="mt-1 mb-0 w-25"
                              style={{ marginRight: 10 }}
                            >
                              <FormSelect
                                name="dateRange"
                                required={true}
                                hideRequiredMark={true}
                                defaultValue={"Quarter to Date"}
                                // label=""
                                label={
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Select Date Range
                                    <Tooltip title={extra?.dataFilterTootip}>
                                      <InfoCircleOutlined
                                        style={{
                                          marginLeft: 8,
                                          fontSize: 12,
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                }
                                // optionLabel="Date Range"
                                // placeholder="Select Date Range"
                                options={[
                                  {
                                    value: "Month to Date",
                                    label: "Month to Date",
                                  },
                                  {
                                    value: "Quarter to Date",
                                    label: "Quarter to Date",
                                  },
                                  {
                                    value: "Year to Date",
                                    label: "Year to Date",
                                  },
                                  {
                                    value: "Custom Date",
                                    label: "Custom Date",
                                  },
                                ]}
                              />
                            </div>
                            <div className="mt-5 mb-0">
                              {dateRange === "Custom Date" && (
                                <RangePicker
                                  value={
                                    customDateRange
                                      ? [
                                        dayjs(customDateRange[0].toDate()),
                                        dayjs(customDateRange[1].toDate()),
                                      ]
                                      : null
                                  }
                                  onChange={(dates) => {
                                    if (dates && dates[0] && dates[1]) {
                                      setCustomDateRange([dates[0], dates[1]]);
                                    } else {
                                      setCustomDateRange(null);
                                    }
                                  }}
                                  style={{ width: "100%" }}
                                />
                              )}
                            </div>
                          </div>
                        )}
                        {customFiltersJSX}
                      </div>
                      {/* // )} */}
                    </div>
                  ) : null}

                  <div
                    className="d-flex align-items-center mb-2 justify-content-end"
                    style={{
                      width: "400px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <SearchInput
                        name="search"
                        placeholder="Search..."
                        width="100%"
                        prefixIcon={<SearchOutlined />}
                        onDebouncedSearch={async (value: any) => {
                          if (extra?.clientSideSearch) {
                            setClientSearchText(value || "");
                            return;
                          }
                          setsearchQuery(value);
                          setPagination({
                            ...pagination,
                            current: 1,
                          });
                          await fetchData({
                            oldPage: 1,
                            current: 1,
                            sortOrder: "DESC",
                            pageSize: pagination.pageSize.toString(),
                            direction: "P",
                            pageDiff: 0,
                            paginationId: null,
                            searchQuery: value,
                            selectFilter1,
                            selectFilter2,
                            selectFilter3,
                            dateRange,
                            customDateRange,
                          });
                        }}
                        debounceDelay={300}
                      />
                    </div>
                    <div style={{ marginLeft: "8px" }}>
                      <UncontrolledDropdown>
                        <DropdownToggle
                          tag="div"
                          className="dropdown-toggle btn btn-icon btn-trigger"
                          onClick={(ev) => {
                            ev.preventDefault();
                            refreshData();
                          }}
                        >
                          <Icon name="redo" />
                        </DropdownToggle>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                </form>
              </FormProvider>
              <div className="content clearfix">
                {loading === true ? (
                  <>
                    <Flex align="center" gap="middle" className="pageLoader">
                      <Spin size="large" className="m-auto" />
                    </Flex>
                  </>
                ) : filteredDataSource?.length > 0 ? (
                  <div
                    style={{
                      width: screenSize - (sideNavigation ? 330 : 100) + "px",
                      margin: "0px auto",
                    }}
                  >
                    <Form form={form} component={false}>
                      <Table
                        className="customTable"
                        columns={columns}
                        rowSelection={rowSelection}
                        dataSource={filteredDataSource}
                        pagination={effectivePagination}
                        onChange={extra?.clientSideSearch ? undefined : tableOnChange}
                        components={components}
                        bordered
                        size="middle"
                        scroll={{
                          x: extra?.tableScrollX || 1500,
                        }}
                      />
                    </Form>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Empty description="No Data Found " />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Card>
      </Content >
    </>
  );
};

export default TransactionFlowDefaultTemplate;
